import {Record} from '../../../../../stores/Form/Record';
import {SETTINGS_KEY} from './consts';
import {Namespace} from '../../../../../services/proto/ServerStorage/utils';

export function getFieldValueByName(file: Record, fieldName: string) {
    const id: number = file.parentForm.getColumnByName(fieldName)?.id;
    if (id) {
        const field = file.getField(id);
        return field?.origValue;
    }
    return '';
}

export function getFieldObjValueByName(file: Record, fieldName: string) {
    const id: number = file?.parentForm?.getColumnByName(fieldName)?.id;
    if (id) {
        const field = file.getField(id);
        return field?.Value;
    }
    return null;
}

export function getColumnTitle(file: Record, fieldName: string) {
    return file.parentForm.getColumnByName(fieldName)?.Title;
}

export const getSettingsKey = (formName: string) => {
    return `${Namespace.Form}/${SETTINGS_KEY}/${formName}`;
};
